function ModalConfirmDeleteSlide({deleteSlide, selectedSlideIndex, reRender}){

    const handleSeleteSlide = () => {
        deleteSlide(selectedSlideIndex);
        reRender();
        window.jQuery('#tbcourse-modal-confirm-delete-slide').modal('hide');
    }
    return (
        <div className={`tbcourse-modal tbcourse-modal-active-lesson modal-mobile-builder modal`} id="tbcourse-modal-confirm-delete-slide" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header border-0">
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body font-family-inter pt-0">
                        <h3 className="font-size-28" style={{'color':'#FF6636'}}>Delete Section</h3>
                        <p className="font-size-14">Are you sure to delete this section ?</p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-outline-black font-weight-bold px-4 py-2 font-size-12 px-4 py-2" data-bs-dismiss="modal">No</button>
                        <button type="button" className="btn btn-primary font-weight-bold rounded-6 font-size-12 px-4 py-2" onClick={handleSeleteSlide}>Yes</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalConfirmDeleteSlide;